import { CombinedError } from 'urql';

import { ValidateOrganisationCodeQuery, useValidateOrganisationCodeQuery } from '../generated/professional-referral';

const useValidateOrganisationCode = (
  orgCode?: string
): [
  ValidateOrganisationCodeQuery['validateOrganisationCode'] | undefined,
  boolean,
  CombinedError | undefined,
  ReturnType<typeof useValidateOrganisationCodeQuery>[1]
] => {
  const [{ data, fetching, error }, reexecuteQuery] = useValidateOrganisationCodeQuery({
    variables: { orgCode: orgCode ?? '' },
    pause: !orgCode?.trim(),
    requestPolicy: 'cache-and-network',
  });

  return [data?.validateOrganisationCode, fetching, error, reexecuteQuery];
};

export { useValidateOrganisationCode };
